<template>
  <section>
    <qx-tab :tabs="tabs" v-model="activeTab" defaultActive="1" />
    <Detail
      ref="detail"
      @vehicleInfo="getVehicleInfo"
      v-show="activeTab === '1'"
    />
    <Operate ref="operate" v-show="activeTab === '2'" />
    <Maintain ref="maintain" v-show="activeTab === '3'" />
  </section>
</template>

<script>
import Detail from './detail/detail.vue';
import Operate from './operate/operate.vue';
import Maintain from './maintain/maintain.vue';
export default {
  components: {
    Detail,
    Operate,
    Maintain,
  },
  data () {
    return {
      activeTab: '1',
      tabs: [
        {
          label: '查看车辆',
          value: '1',
        },
        {
          label: '运营记录',
          value: '2',
        },
        {
          label: '维护记录',
          value: '3',
        },
      ],
    };
  },
  methods: {
    getVehicleInfo (vehicleInfo) {
      if (vehicleInfo.plateNumber) {
        this.$refs.operate && this.$refs.operate.setVehicleInfo(vehicleInfo);
        this.$refs.maintain && this.$refs.maintain.setVehicleInfo(vehicleInfo);
        this.$refs.operate && this.$refs.operate.getData();
        this.$refs.maintain && this.$refs.maintain.getData();
      }
    },
  },
  watch: {
    '$route.query.id': function () {
      this.$refs.detail.getData();
    },
    '$route.query.plateNumber': function () {
      this.$refs.detail.getData();
    },
  },
};
</script>

<style>
</style>
